import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Row, Col } from 'antd';
import { FormattedMessage } from 'react-intl';
import CardCheckMessage from '../UI/CardCheckMessage';
import axios from 'axios';
import useInterval from '../../comp/hooks/useInterval';
import JoinSteps from '../UI/JoinSteps';
import useMessage from '../../comp/hooks/useMessage';

const MIN_RESEND_PERIOD_IN_SECONDS = 30;

const Presignup = ({ plan, form, captchaToken }) => {
  const { message } = useMessage();
  const [loading, setLoading] = useState(false);
  const [counter, setCounter] = useState(MIN_RESEND_PERIOD_IN_SECONDS);
  const requestValues = form.getFieldsValue(true);

  useInterval(() => {
    setCounter((counter) => counter - 1);
  }, 1000);

  const resend = async () => {
    setLoading(true);
    try {
      const values = {
        ...requestValues,
        target: '/',
        isPodcaster: true,
        gCaptchaToken: captchaToken,
        resend: true,
      };
      delete values.agreeBox;

      await axios.post('/api/session/join', values);

      // redirection
      message.success({
        content: <FormattedMessage defaultMessage="We have resend you a new activation link" />,
        duration: 1,
      });

      setCounter(MIN_RESEND_PERIOD_IN_SECONDS);
    } catch (error) {
      message.danger({
        content: error?.response?.data?.message || (
          <FormattedMessage defaultMessage="We could not create an account at this time" />
        ),
      });
    }

    setLoading(false);
  };

  return (
    <Col lg={12} md={22} sm={22} xs={22}>
      <JoinSteps currentStep={0} noCreditCard={plan?.isCreatorNetwork} />

      <Row
        gutter={{ xs: 14, sm: 14, md: 30, lg: 30, xxl: 30 }}
        type="flex"
        justify="center"
        align="middle"
        className="gutter-top-lg"
      >
        <Col sm={24}>
          <Row gutter={{ xs: 14, sm: 14, md: 30, lg: 30, xxl: 30 }} className="gutter-bottom-lg">
            <Col sm={24}>
              <h2>
                <FormattedMessage defaultMessage="Please verify your account" />
              </h2>
            </Col>
          </Row>
          <Row gutter={{ xs: 14, sm: 14, md: 30, lg: 30, xxl: 30 }} className="gutter-bottom-lg">
            <Col sm={24}>
              <h3>
                <FormattedMessage
                  defaultMessage="We have sent an email to <b>{email}</b>."
                  values={{
                    b: (chunks) => (
                      <span style={{ fontFamily: 'IBM-Plex-Sans-Bold' }}>{chunks}</span>
                    ),
                    email: requestValues.email,
                  }}
                />
              </h3>
              <h3>
                <FormattedMessage defaultMessage="Please click the link in the email to verify your account." />
              </h3>
            </Col>
          </Row>
          <Row gutter={{ xs: 14, sm: 14, md: 30, lg: 30, xxl: 30 }} className="gutter-bottom-lg">
            <Col sm={24}>
              <h3>
                <FormattedMessage defaultMessage="Didn't receive the email?" />
                <span> </span>
                {counter > 0 ? (
                  <FormattedMessage
                    defaultMessage="You can resend it in {seconds} seconds"
                    values={{ seconds: counter }}
                  />
                ) : (
                  <FormattedMessage defaultMessage="You can resend it now" />
                )}
              </h3>
              <Button
                block
                loading={loading}
                size="large"
                type="primary"
                shape="round"
                style={{ fontWeight: 700 }}
                disabled={counter > 0}
                onClick={resend}
              >
                <FormattedMessage defaultMessage="Resend" />
              </Button>
            </Col>
          </Row>
          {plan?.isStarter && (
            <Row gutter={{ xs: 14, sm: 14, md: 30, lg: 30, xxl: 30 }}>
              <Col sm={24}>
                <CardCheckMessage />
              </Col>
            </Row>
          )}
        </Col>
      </Row>
    </Col>
  );
};

Presignup.propTypes = {
  plan: PropTypes.object.isRequired,
  form: PropTypes.object.isRequired,
  captchaToken: PropTypes.string,
};

export default Presignup;
